"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var _1 = require("../util/_");
var Swipeable = /** @class */ (function (_super) {
    __extends(Swipeable, _super);
    function Swipeable(props) {
        var _this = _super.call(this, props) || this;
        _this.initialState = function () {
            return {
                x: undefined,
                y: undefined,
                swiping: false,
                start: 0
            };
        };
        _this.calculatePos = function (e) {
            var x = e.changedTouches[0].clientX;
            var y = e.changedTouches[0].clientY;
            var xd = _this.state.x - x;
            var yd = _this.state.y - y;
            var axd = Math.abs(xd);
            var ayd = Math.abs(yd);
            var time = Date.now() - _this.state.start;
            var velocity = Math.sqrt(axd * axd + ayd * ayd) / time;
            return {
                deltaX: xd,
                deltaY: yd,
                absX: axd,
                absY: ayd,
                velocity: velocity
            };
        };
        _this.touchStart = function (e) {
            if (e.touches.length > 1) {
                return;
            }
            _this.setState({
                start: Date.now(),
                x: e.touches[0].clientX,
                y: e.touches[0].clientY,
                swiping: false
            });
        };
        _this.touchMove = function (e) {
            if (!_this.state.x || !_this.state.y || e.touches.length > 1) {
                return;
            }
            var cancelPageSwipe = false;
            var pos = _this.calculatePos(e);
            if (pos.absX < _this.props.delta && pos.absY < _this.props.delta) {
                return;
            }
            if (_this.props.onSwiping) {
                _this.props.onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
            }
            if (pos.absX > pos.absY) {
                if (pos.deltaX > 0) {
                    if (_this.props.onSwipingLeft) {
                        _this.props.onSwipingLeft(e, pos.absX);
                        cancelPageSwipe = true;
                    }
                }
                else {
                    if (_this.props.onSwipingRight) {
                        _this.props.onSwipingRight(e, pos.absX);
                        cancelPageSwipe = true;
                    }
                }
            }
            else {
                if (pos.deltaY > 0) {
                    if (_this.props.onSwipingUp) {
                        _this.props.onSwipingUp(e, pos.absY);
                        cancelPageSwipe = true;
                    }
                }
                else {
                    if (_this.props.onSwipingDown) {
                        _this.props.onSwipingDown(e, pos.absY);
                        cancelPageSwipe = true;
                    }
                }
            }
            _this.setState({ swiping: true });
            if (cancelPageSwipe && _this.props.preventDefaultTouchmoveEvent) {
                e.preventDefault();
            }
        };
        _this.touchEnd = function (ev) {
            if (_this.state.swiping) {
                var pos = _this.calculatePos(ev);
                var isFlick = pos.velocity > _this.props.flickThreshold;
                _this.props.onSwiped && _this.props.onSwiped(ev, pos.deltaX, pos.deltaY, isFlick);
                if (pos.absX > pos.absY) {
                    if (pos.deltaX > 0) {
                        _this.props.onSwipedLeft && _this.props.onSwipedLeft(ev, pos.deltaX, isFlick);
                    }
                    else {
                        _this.props.onSwipedRight && _this.props.onSwipedRight(ev, pos.deltaX, isFlick);
                    }
                }
                else {
                    if (pos.deltaY > 0) {
                        _this.props.onSwipedUp && _this.props.onSwipedUp(ev, pos.deltaY, isFlick);
                    }
                    else {
                        _this.props.onSwipedDown && _this.props.onSwipedDown(ev, pos.deltaY, isFlick);
                    }
                }
            }
            _this.setState(_this.initialState());
        };
        _this.state = _this.initialState();
        return _this;
    }
    Swipeable.prototype.render = function () {
        var customProps = _1.omit(this.props, Object.keys(Swipeable.propTypes));
        return (React.createElement("div", __assign({}, customProps, { onTouchStart: this.touchStart, onTouchMove: this.touchMove, onTouchEnd: this.touchEnd }), this.props.children));
    };
    Swipeable.propTypes = {
        onSwiped: PropTypes.func,
        onSwiping: PropTypes.func,
        onSwipingUp: PropTypes.func,
        onSwipingRight: PropTypes.func,
        onSwipingDown: PropTypes.func,
        onSwipingLeft: PropTypes.func,
        onSwipedUp: PropTypes.func,
        onSwipedRight: PropTypes.func,
        onSwipedDown: PropTypes.func,
        onSwipedLeft: PropTypes.func,
        flickThreshold: PropTypes.number,
        delta: PropTypes.number,
        preventDefaultTouchmoveEvent: PropTypes.bool,
        children: PropTypes.node
    };
    Swipeable.defaultProps = {
        flickThreshold: 0.6,
        delta: 10,
        preventDefaultTouchmoveEvent: true
    };
    return Swipeable;
}(React.Component));
exports.Swipeable = Swipeable;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/swipeable/swipeable.js
// module id = 584
// module chunks = 0 1 2 3 4 5 6